<template>
  <div class="tags-flx">
    <template v-if="data.list.length">
      <Col v-for="(item, index) in data.list" :key="index" :span="data.colSpan">
        <div class="tags-flx-item" :style="data.tuoguanStyle">
          <h2 class="tags-flx-title">{{ item.name }}</h2>
          <div class="tags-flx-content">
            <p
              v-for="(elx, idx) in item.children"
              :key="idx"
              class="tags-flx-num"
            >
              <span class="label">{{ elx.label }}</span>
              <span class="value">{{ elx.value }}</span>
            </p>
          </div>
        </div>
      </Col>
    </template>
    <template v-else>
      <emptyTip></emptyTip>
    </template>
  </div>
</template>

<script>
import emptyTip from './empty.vue';
export default {
  components: {
    emptyTip
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-flx {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  box-sizing: border-box;
  /deep/.ivu-col {
    height: 150px;
    &:first-child {
      margin-bottom: 10px;
    }
  }
  &-item {

    // width: 490px;
    //  height: 166px;
    // padding: 30px 20px;
    // margin-bottom: 30px;
    background: #f7f7f9;
    border-radius: 4px;
    .tags-flx-title {

      margin-bottom: 30px;
      font-size: 16px;
      font-weight: 600;
      color: #444444;
    }
    .tags-flx-content {
      width: 100%;
      display: flex;
    }
    .tags-flx-num {
      flex: 1;
      padding-left: 10px;
      .label {
        margin-right: 10px;
        font-size: 14px;
        color: #666666;
        vertical-align: text-top;
      }
      .value {
        font-size: 30px;
        font-weight: 600;
        color: #444444;
      }
    }
  }
}
</style>
